import {IFarmListPayload, IFarmListResponse} from './types';
import request from '../../axios';

interface IProps {
  pageParam: number;
  payload?: IFarmListPayload;
}

export const getFarmList = async ({pageParam, payload}: IProps) => {
  // Extract `enabled` from the payload (if it exists) because it's just for the React Query
  const {enabled, permission_types, ...rest} = payload ?? {};

  const permissionTypesParam =
    permission_types?.length && permission_types.length > 1
      ? permission_types.join(',')
      : permission_types?.[0];

  const {data}: {data: IFarmListResponse} = await request.get(
    `/api/v2/farm/list-farm`,
    {
      params: {
        page: pageParam,
        page_size: payload?.page_size ?? 10,
        ...(permissionTypesParam && {permission_types: permissionTypesParam}),
        ...rest,
      },
    },
  );

  return data;
};
